<template>
  <div class="alertNameBox">
    <nav-bar :title="$t('修改昵称')" bg-color="transparent" left-arrow left-color="#fff" title-color="#fff" />
    <div class="alertBox">
      <van-field v-model="value" :border="false" :label="$t('昵称')" :placeholder="$t('请输入昵称')" input-align="right" />
      <p class="alertBtn" @click="save()">{{ $t('保存') }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        value: "",
      }
    },
    computed: {},
    watch: {},
    methods: {
      getMemberInfo() {
        this.$get({
          url: `/member/getMemberInfo`,
          loading: !this.local.get('mine_memberInfo'), // 如果有缓存就不显示loading
          success: (res) => {
            this.value = res.data.nickname
            // 更新缓存
            this.local.set('mine_memberInfo', JSON.stringify(res.data))
          },
          tip: () => {
          }
        })
      },
      save() {
        if (!this.value) return this.$toast(this.$t('请输入昵称'))
        this.$post({
          url: `/member/editNickName`,
          loading: true,
          data: {
            nickname: this.value
          },
          success: (res) => {
            this.$toast(res.message)
          },
          tip: () => {
          }
        })
      },
    },
    created() {
      // 检查缓存
      const cachedMemberInfo = this.local.get('mine_memberInfo')
      if (cachedMemberInfo) {
        const info = JSON.parse(cachedMemberInfo)
        this.value = info.nickname
      }
      this.getMemberInfo()
    },
    mounted() {
    },
  }
</script>

<style lang="less" scoped>
  .alertNameBox {
    width: 100%;
    min-height: 100vh;
    background-color: #446D7A;
    padding: 15px;
    .alertBox {
      ::v-deep .van-field {
        background-color: rgba(52, 54, 56, 0.5);;
        border-radius: 8px;
        .van-field__label {
          color: #ffffff;
        }
        .van-field__value {
          .van-field__control {
            color: #ffffff;
          }
        }
      }
      .alertBtn {
        background-color: #bb9d67;
        color: #ffffff;
        margin-top: 150px;
        padding: 10px 0;
        text-align: center;
        border-radius: 8px;
      }
    }
  }
</style>
